import React from "react";
import BottomNav from "./layouts/championBottomNav";
import Confetti from "react-confetti";
import { useTranslation } from "react-i18next";
import { COMP_QUESTIONS_POINTS, NUM_OF_COMP_QUESTIONS } from "constants/constants";
import "./css/loss.css";

const LossGames = (props) => {
  const { t } = useTranslation();

  return (
    <>
      {props.userScore > props.opponentScore && (
        <Confetti width={window.width} height={window.height} />
      )}
      <div className="home">
        <div className="main">
          <div className="page-header"></div>
          <div className="container box-wrapper loss-wrap">
            <div className="text-center pb-4">
              <div className="quiz-result-pict">
                <div className="quiz-result-pict-ava ">
                  {props.userScore > props.opponentScore ? (
                    <img src="/image/won.png" alt="won" />
                  ) : (
                    <img src="/image/loss.png" alt="lost" />
                  )}
                </div>
              </div>
              <h5 className="text-white pt-5">{t("75")}</h5>
            </div>

            <div className="final-score">
              <div className="text-center final-card">
                <div className="final-score-title">
                  <p className="m-0">{t("33")}</p>
                </div>
              </div>
              <div className="final-score-top">
                <div className="row">
                  <div className="col-12 text-center">
                    <div className="final-score-top-box mb-3">{props.userScore * 1}</div>
                    <div className="row gx-0 final-score-more">
                      <div className="col-12 text-center">
                        <p className="mb-0">
                          <span className="right-text ">{t("34")}:</span>{" "}
                          <span className="score-stats-badge ">{props.userScore}</span>
                          <span className="wrong-text ms-2">{t("35")}:</span>{" "}
                          <span className="score-stats-badge2">
                            {NUM_OF_COMP_QUESTIONS * COMP_QUESTIONS_POINTS - props.userScore}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BottomNav state={props.state.qid} />
    </>
  );
};

export default LossGames;
